// extracted by mini-css-extract-plugin
export default {"secondary-block":"Wrgjv","item":"Y0Xdw"};